var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.9998H15M17 19.9998H7C5.93913 19.9998 4.92172 19.5784 4.17157 18.8282C3.42143 18.0781 3 17.0607 3 15.9998V9.70782C2.99999 9.02003 3.17732 8.34386 3.51487 7.74461C3.85242 7.14536 4.33879 6.64326 4.927 6.28682L9.927 3.25682C10.5521 2.87801 11.2691 2.67773 12 2.67773C12.7309 2.67773 13.4479 2.87801 14.073 3.25682L19.073 6.28682C19.6611 6.64317 20.1473 7.14511 20.4849 7.74417C20.8224 8.34324 20.9998 9.0192 21 9.70682V15.9998C21 17.0607 20.5786 18.0781 19.8284 18.8282C19.0783 19.5784 18.0609 19.9998 17 19.9998Z",
    stroke: "#5D6679",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.214c52b62412adf2a75aa770ca0c8108.svg";
export { ForwardRef as ReactComponent };